export default {
  data() {
    return {
      scrollTop: 0,
    }
  },
  methods: {
    /**
     * 页面/区域滚动；兼容 window、document、body、documentElement 及内部可滚动容器
     */
    initScroll(e) {
      const t = e && e.target
      if (!t || t === document.body || t === document.documentElement || t === document || t === window) {
        this.scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0
        return
      }
      if (typeof t.scrollTop === 'number') {
        this.scrollTop = t.scrollTop
        return
      }
      this.scrollTop = 0
    },
  },
  created() {
    document.body.addEventListener('scroll', this.initScroll)
  },
  mounted() {
    window.addEventListener('scroll', this.initScroll, { passive: true })
    this.$nextTick(() => {
      this.initScroll({ target: document.documentElement })
    })
  },
  beforeDestroy() {
    document.body.removeEventListener('scroll', this.initScroll)
    window.removeEventListener('scroll', this.initScroll)
  },
}
